/** @fileoverview Provides persistent light, dark, and system theme selection. */

import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';
import { Button } from './ui/button';

const THEME_OPTIONS = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor },
] as const;

/** Renders the persisted theme choice as a compact three-button bar. */
export default function ThemeSelector() {
  const { theme, chooseTheme } = useTheme();

  return (
    <div className="p-2" role="group" aria-label="Theme">
      <div className="grid grid-cols-3 gap-1 rounded-md border border-app-border-strong bg-app-surface-muted-strong p-1">
        {THEME_OPTIONS.map(({ value, label, icon: Icon }) => (
          <Button
            key={value}
            type="button"
            size="sm"
            variant="ghost"
            className={`h-8 min-w-0 flex-col gap-0 px-1 text-xs leading-none ${
              theme === value
                ? 'bg-app-surface-card text-app-text shadow-sm ring-1 ring-inset ring-app-border hover:bg-app-surface-card'
                : 'text-app-text-muted'
            }`}
            aria-label={label}
            title={label}
            aria-pressed={theme === value}
            onClick={() => chooseTheme(value)}
          >
            <Icon className="h-3.5 w-3.5" aria-hidden="true" />
          </Button>
        ))}
      </div>
    </div>
  );
}
